export default __webpack_public_path__ + "static/media/4.9dd18ebe.png";